import React from 'react';
const SEOCheckerIcon = () => {
  return <svg width="20" height="21" viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 10.5H6.66667L8.33333 7.16663L11.6667 14.6666L13.3333 10.5H15" stroke="#5C5F62" fill="none" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M1.66669 5.49996C1.66669 3.65901 3.15907 2.16663 5.00002 2.16663H15C16.841 2.16663 18.3334 3.65901 18.3334 5.49996V15.5C18.3334 17.3409 16.841 18.8333 15 18.8333H5.00002C3.15907 18.8333 1.66669 17.3409 1.66669 15.5V5.49996Z" stroke="#5C5F62" fill="none" strokeWidth="1.25"/>
  </svg>
};

export default SEOCheckerIcon;
